'use strict';

import React, { Component } from 'react';
import { Map, Polygon, GoogleApiWrapper } from 'google-maps-react';
import { isMobile } from "react-device-detect";

import MapCluster from './MapCluster';

import mapStyles from '../../settings/mapStyle';
import globalConfig from '../../settings/config';

class MapMain extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mapData: [],
      polygons: [],
    };

    this.updateMapTimeout = '';
    this.handleZoomChanged = this.handleZoomChanged.bind(this);
    this.handleMapReady = this.handleMapReady.bind(this);
    this.updateMap = this.updateMap.bind(this);
    this.infoWindows = [];
    this.processSize = this.processSize.bind(this);
    this.handleDragend = this.handleDragend.bind(this);
    this.handleCenterChanged = this.handleCenterChanged.bind(this);
  }

  /* Component lifecycle events */
  componentWillUpdate(nextProps, nextState) {
    if (
      !this.mapCluster &&
      this.mapRef &&
      nextProps.markers &&
      nextProps.markers.length > 0
    ) {
      this.mapCluster = new MapCluster(
        nextProps.markers,
        this.mapRef,
        nextProps.google.maps,
        this.props.selectedThemeColor
      );
      nextProps.handleMapCompelted();
    }
  }

  /* Event Handlers */
  handleMapReady(mapProps, map) {
    this.mapApi = mapProps.google.maps;
    this.mapRef = map;

    if (this.mapApi && this.mapRef) {
      this.props.setGlobalMapApi(this.mapApi, this.mapRef);
    }
  }

  handleZoomChanged(mapProps, map) {
    clearTimeout(this.updateMapTimeout);
    this.updateMapTimeout = window.setTimeout(() => {
      //console.log('***** func handleZoomChanged *****');
      this.props.setCurrentZoomLevel(map.zoom);
      //Please don't remove the following line. Check Dev Dairy for more info
      //this.updateMap(map);
      this.props.handleReloadEventListRequest();
    }, 750);
  }

  handleDragend(mapProps, map) {
    clearTimeout(this.updateMapTimeout);
    this.updateMapTimeout = window.setTimeout(() => {
      //console.log('***** func handleDragend *****');
      //Please don't remove the following line. Check Dev Dairy for more info
      //this.updateMap(map);
      this.props.handleReloadEventListRequest();
    }, 750);
  }

  /*
  **This function is added back to reload event lists only.
  */
  handleCenterChanged(mapProps, map) {
    clearTimeout(this.updateMapTimeout);
    this.updateMapTimeout = window.setTimeout(() => {
      this.props.handleReloadEventListRequest();
    }, 750);
  }

  /* helpers */
  updateMap(map) {
    let viewStitchLevel = 10;
    if (isMobile) {
      viewStitchLevel = 11;
    }
    if (map.zoom >= viewStitchLevel) {
      this.props.handleMapDataLoading();
      this.props.handleReloadMapRequest();
      this.mapCluster && this.mapCluster.clearMarkers();
    } else if (map.zoom < viewStitchLevel && this.props.markers.length === 0) {
      this.props.handleReloadMapRequest();

      window.setTimeout(() => {
        this.mapCluster && this.mapCluster.addMarkers();
      }, 1000);
    }
  }

  drawPolygons(polygons) {
    const SnazzyInfoWindow = require('snazzy-info-window');

    if (polygons.length > 0) {
      return polygons.map(({ center, coordinates, content }, index) => {
        const infoWindow = new SnazzyInfoWindow({
          map: this.mapRef,
          position: center,
          padding: '0px',
          openOnMarkerClick: true,
          closeWhenOthersOpen: true,
          showCloseButton: true,
        });

        this.infoWindows.push(infoWindow);

        return (
          <Polygon
            key={`polygon-${index}`}
            paths={coordinates}
            strokeColor={this.props.selectedThemeColor}
            strokeOpacity={1}
            strokeWeight={1}
            fillColor={this.props.selectedThemeColor}
            fillOpacity={0.5}
            center={center}
            content={content}
            onClick={({ content }) => {
              infoWindow.setContent(this.getInfoContent(content));
              infoWindow.open();
            }}
          />
        );
      });
    } else if (this.infoWindows.length > 0) {
      this.infoWindows.forEach(item => item.destroy());
      this.infoWindows = [];
    }
    return null;
  }

  processSize(size) {
    var temp = size.split(' ');
    return parseFloat(temp[0]) + ' ' + temp[1];
  }

  getInfoContent(content) {
    let hr_by = '';
    if (content.supportingAgencies && content.supportingAgencies != null) {
      hr_by += content.supportingAgencies + ', ';
    }
    if (content.leadAgency) {
      hr_by += content.leadAgency;
    }

    return `<div class="o__infowindow">
      <div class="info__heading">
        <h5>${content.location}</h5>
      </div>

      <div class="info__content">
        <ul>
          <li>
            <span>Location:</span>
            <span>${content.lga}</span>
          </li>
          <li>
            <span>Date:</span>
            <span>
              ${content.startDate}
              ${' - '}
              ${content.endDate}
            </span>
          </li>
          <li>
            <span>Tenure:</span>
            <span>${content.tenure}</span>
          </li>
          <li>
            <span>HR By:</span>
            <span>
              ${hr_by}
            </span>
          </li>
          <li>
            <span>Size:</span>
            <span>${this.processSize(content.size)}</span>
          </li>
        </ul>
      </div>
    </div>`;
  }

  render() {
    return (
      <div>
        <Map
          google={this.props.google}
          styles={mapStyles}
          initialCenter={globalConfig.map.default.center}
          center={this.props.mapCenter}
          zoom={this.props.currentZoom}
          minZoom={globalConfig.map.default.minZoom}
          onDragend={this.handleDragend}
          onZoom_changed={this.handleZoomChanged}
          onCenter_changed={this.handleCenterChanged}
          onReady={this.handleMapReady}
        >
          {this.drawPolygons(this.props.polygons)}
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper(props => ({
  client: 'gme-nswruralfireservice',
  channel: 'PWS_FNM',
}))(MapMain);